import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import classNames from 'classnames';

import Header from './landing/Header';
import Footer from './landing/Footer';
import ThemeProvider from './ThemeProvider';

import '../../assets/sass/pages/landing/layout/layout.scss';

class LandingLayout extends Component {
    
    appClassName = () => {
        const classes = classNames(
            "landing-layout"
        );

        return classes;
    }

    render() {
        
        return (
            <ThemeProvider floatSwitch>
                <div id={ this.props.id } className={ this.appClassName() }>
                    <Header />
                    <main className="main-wrapper">
                        {this.props.children}
                    </main>
                    <Footer />
                </div>
            </ThemeProvider>
        );
    }
}

export default withRouter(LandingLayout);
